import { render, staticRenderFns } from "./ModalTermo.vue?vue&type=template&id=21e4fea0&"
import script from "./ModalTermo.vue?vue&type=script&lang=js&"
export * from "./ModalTermo.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports